export default __webpack_public_path__ + "static/cer-2-4d55abe19dc364aa361cb8939603d153.webp";